/* 🤖 this file was generated by svg-to-ts */
export var spxIconPlusSign = {
    name: 'plus_sign',
    data: "<svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9 3L9 15M15 9L3 9\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>"
};
